/* eslint-disable import/no-anonymous-default-export */
export default {
  comparison: 'Compare',
  comparison_humiture: 'Compare Temp & RH Monitors',
  comparison_air: 'Compare Air Monitors',
  buy: 'Buy',
  moreDetail: 'Learn more >',
  batteryIcon: 'Battery icon',
  probeIcon: 'External Probes',
  waterproofIcon: 'Water Splash and Dust Resistance',
  supportAppIcon: 'Supported App',
  cp_supportApp_mi: 'Mi Home',
  cp_supportApp_mi_note: 'The products support Mi Home\'s servers in Chinese mainland only.',
  cp_supportApp_plus: 'Qingping+',
  cp_supportApp_plus_note: 'You can use the Qingping+ App to manage Qingping smart home devices, including viewing data, modifying settings, upgrading firmware, and more.',
  cp_supportApp_iot: 'Qingping IoT',
  cp_supportApp_iot_note: 'Qingping IoT is a platform that provides devices management, data collection, visualization, and real-time alerting services for teams.',
  cp_supportApp_plus_only_wifi_note: 'Only the Wi-Fi version supports Qingping+.',
  cp_supportApp_magpie: 'Lee Guitars Temp & RH',
  cp_supportApp_appleHomeKit: 'Apple Home',
  cp_supportApp_appleHomeKit_note: 'To remotely access the data with AppleHome, you need to set up HomePod or Apple TV as a home hub.',
  display_eink: 'E-Ink display',
  display_segment: 'Low-power LCD',
  display_size_50mm: '50 × 50 mm',
  display_size_61x49mm: '61 × 49 mm',
  display_size_64x44mm: '64.6 × 44.6 mm',
  display_size_30x19mm: '30 × 19 mm',
  detection_items: 'Measurement Parameters',
  comparison_display: 'Display',
  external_probe: 'External Probes',
  dust_proof_waterproof: 'Water Splash and Dust Resistance',
  range: 'Measurement Range',
  size_weight: 'Size and Weight',
  wireless_communication: 'Wireless Connectivity',
  supported_apps: 'Supported App',
  remote_monitoring: 'Remote Access',
  power_and_battery_life: 'Power Options',
  placement_and_installation: 'Placing and Mounting Option',
  cp_range_label_temp: 'Temperature:',
  cp_range_label_humidity: 'Humidity:',
  cp_goose3_display_type: 'E-Ink display',
  cp_goose3_display_size: '50 × 50 mm',
  cp_goose3_range_0_value: '0 ~ 50℃',
  cp_goose3_range_1_value: '0 ~ 99.9%RH (no condensation)',
  cp_goose3_range_1_note: 'Do not place this product in environment with humidity higher than 90% for long term use.',
  cp_goose3_wireless_desc: 'Bluetooth',
  cp_goose3_sizeWeight_0_items_0_label: '70 × 70 × 19 mm',
  cp_goose3_sizeWeight_0_items_1_label: '48 g (excluding stand and battery)',
  cp_goose3_powerInfo_0_label: 'One AAA battery lasts for 12 months',
  cp_goose3_powerInfo_1_label: ' ',
  cp_goose3_powerInfo_1_note: 'The actual battery life may vary depending on the environment and battery.',
  cp_goose3_mounting: 'Desktop mode, wall mode, magnetic mode',
  cp_duck3_display_type: 'Low-power LCD',
  cp_duck3_display_size: '50 × 50 mm',
  cp_duck3_range_0_value: '-9.9 ~ 50℃',
  cp_duck3_range_1_value: '0 ~ 99.9%RH (no condensation)',
  cp_duck3_range_1_note: 'Do not place this product in environment with humidity higher than 90% for long term use.',
  cp_duck3_wireless_desc: 'Bluetooth',
  cp_duck3_sizeWeight_0_items_0_label: '70 × 70 × 19 mm',
  cp_duck3_sizeWeight_0_items_1_label: '55 g (excluding stand and battery)',
  cp_duck3_powerInfo_0_label: 'One AAA battery lasts for 12 months',
  cp_duck3_powerInfo_1_label: ' ',
  cp_duck3_powerInfo_1_note: 'The actual battery life may vary depending on the environment and battery.',
  cp_duck3_mounting: 'Desktop mode, wall mode, magnetic mode',
  cp_pheasant_s_no_pressure_display_type: 'Low-power LCD',
  cp_pheasant_s_no_pressure_display_size: '61 × 49 mm',
  cp_pheasant_s_no_pressure_range_0_value: '-30 ~ 55℃',
  cp_pheasant_s_no_pressure_range_1_value: '0 ~ 99.9%RH (no condensation)',
  cp_pheasant_s_no_pressure_range_1_note: 'Do not place this product in environment with humidity higher than 90% for long term use.',
  cp_pheasant_s_no_pressure_range_2_title_0: 'Air Pressure: 30 ~ 125 kPa',
  cp_pheasant_s_no_pressure_wireless_desc: 'Wi-Fi or NB-IoT or LoRa',
  cp_pheasant_s_no_pressure_sizeWeight_0_items_0_label: '77 × 77 × 28 mm',
  cp_pheasant_s_no_pressure_sizeWeight_0_items_1_label: '129 g',
  
  cp_pheasant_s_no_pressure_powerInfo_0_label: 'USB-C charging port\nHigh-capacity rechargeable lithium battery',
  cp_pheasant_s_no_pressure_mounting: 'Wall mode',
  cp_pheasant_s_display_type: 'Low-power LCD',
  cp_pheasant_s_display_size: '61 × 49 mm',
  cp_pheasant_s_waterproof_desc: 'Main unit: IP55 protection\nAUX temp probe: IP68 protection, can be used in water for a long time',
  cp_pheasant_s_range_0_value: '-30 ~ 60℃',
  cp_pheasant_s_range_1_value: '0 ~ 99.9%RH (no condensation)',
  cp_pheasant_s_range_2_label:'Air Pressure: ',
  cp_pheasant_s_range_2_value: '30 ~ 125 kPa',
  cp_pheasant_s_range_1_note: 'Do not place this product in environment with humidity higher than 90% for long term use.',
  cp_pheasant_s_wireless_desc: 'Wi-Fi or NB-IoT or LoRa',
  cp_pheasant_s_sizeWeight_0_items_0_label: '77 × 77 × 28 mm',
  cp_pheasant_s_sizeWeight_0_items_1_label: '129 g',
  cp_pheasant_s_powerInfo_0_label: 'USB-C charging port\nHigh-capacity rechargeable lithium battery',
  cp_pheasant_s_mounting: 'Wall mode',
  cp_frog_display_type: 'Low-power LCD',
  cp_frog_display_size: '64 × 44 mm',
  cp_frog_probe_desc: 'AUX Temp Probe',
  cp_frog_waterproof_desc: 'Main unit: IP55 protection',
  cp_frog_waterproof_desc2: 'AUX temp probe: IP68 protection, can be used in water for a long time',

  cp_frog_range_0_label: 'Main Unit Temperature:',
  cp_frog_range_0_value_0: '-30 ~ 60°C (powered by lithium-Iron AA batteries or USB)',
  cp_frog_range_0_value_1: '-10 ~ 50°C (powered by alkaline AA batteries)',
  cp_frog_range_1_label: 'Main Unit Humidity:',
  cp_frog_range_1_value_0: '0 ~ 100%RH (battery powered, no condensation)',
  cp_frog_range_1_value_1: '0 ~ 90%RH (USB powered, no condensation)',
  cp_frog_range_1_note: 'Do not place this product in environment with humidity higher than 90% for long term use.',
  cp_frog_range_2_label: 'AUX Temp Probe:',
  cp_frog_range_2_value: '-40 ~ 125℃',
  
  cp_frogs_waterproof_desc: 'Main unit: IP56',
  cp_frogs_waterproof_desc2: 'Temp probe: IP68, dust resistance and can be soaked in water',
  
  cp_frogs_probe_desc_0: 'Temperature Probe',
  cp_frogs_probe_desc_1: 'High-Concentration CO2 Probe (Flat Cable)',
  cp_frogs_range_0_title_0: 'Main Unit Temperature',
  cp_frogs_range_0_title_1: '-30 ~ 60°C (powered by lithium-Iron AA batteries or USB)',
  cp_frogs_range_0_title_2: '-10 ~ 50°C (powered by alkaline AA batteries)',
  cp_frogs_range_1_title_0: 'Main Unit Humidity',
  cp_frogs_range_1_title_1: '0 ~ 100%RH',
  cp_frogs_range_1_note: 'Do not place this product in environment with humidity higher than 90% for long term use.',
  cp_frogs_range_2_title_0: 'Temp Probe',
  cp_frogs_range_2_title_1: '-40 ~ 125℃',
  cp_frogs_range_3_title_0: 'High-Concentration CO2 Probe (Flat Cable):',
  cp_frogs_range_3_title_1: '0 ~ 25%',
  cp_frog_wireless_desc: 'Wi-Fi or NB-IoT or LoRa',
  cp_frog_sizeWeight_0_items_0_label: 'Main unit:',
  cp_frog_sizeWeight_0_items_1_label: '87.6 × 156.8 × 33 mm (with antenna)',
  cp_frog_sizeWeight_0_items_2_label: '118 g',
  cp_frog_sizeWeight_1_items_0_label: 'AUX temp probe:',
  cp_frog_sizeWeight_1_items_1_label: 'Sensor probe: ',
  cp_frog_sizeWeight_1_items_1_value: 'Diameter 6 mm, length 50 mm;',
  cp_frog_sizeWeight_1_items_2_label: 'Cable: ',
  cp_frog_sizeWeight_1_items_2_value: 'Diameter 3.5 mm, length 1500 mm;',
  cp_frog_sizeWeight_1_items_3_label: 'Suction cup bracket: ',
  cp_frog_sizeWeight_1_items_3_value: 'Diameter 35 mm, height 20 mm',
  cp_frog_sizeWeight_1_items_4_label: '29 g',
  cp_frog_powerInfo_0_label: 'Powered by AA batteries\nPowered through the Micro-USB port',
  cp_frog_powerInfo_0_note: 'The product can be powered by USB all the time, but it does not support battery charging.',
  cp_frogs_powerInfo_0_label: 'Powered by AA batteries\nPowered through the USB-C port',
  cp_frogs_powerInfo_0_note: 'The product can be powered by USB all the time, but it does not support battery charging.',
  cp_frog_mounting: 'DIN rail compatible, Magnets built-in',
  cp_gecko_display_type: 'Low-power LCD',
  cp_gecko_display_size: '30 × 19 mm',
  cp_gecko_range_0_value: '-20 ~ 50℃',
  cp_gecko_wireless_desc: 'NB-IoT',
  cp_gecko_sizeWeight_0_items_0_label: '86 × 86 × 38.5 mm (11.5 mm outside the wall)',
  cp_gecko_sizeWeight_0_items_1_label: '126.8 g',
  cp_gecko_powerInfo_0_label: 'Powered via wall junction box',
  cp_gecko_powerInfo_1_label: 'Rated voltage:',
  cp_gecko_powerInfo_1_value: '250V AC',
  cp_gecko_powerInfo_2_label: 'Rated current:', 
  cp_gecko_powerInfo_2_value: '10A max',
  cp_gecko_powerInfo_3_note: 'The product takes power directly through the wall box.',

  cp_gecko_mounting: '86-type wall socket',
  cp_gecko_mountingNote: 'The 86-type box is an 86 × 86 mm wall box.',
  cp_magpie_display_type: 'E-Ink display',
  cp_magpie_display_size: '26 × 26 mm',
  cp_magpie_range_0_value: '0 ~ 50℃',
  cp_magpie_range_1_value: '0 ~ 99.9%RH (no condensation)',
  cp_magpie_range_1_note: 'Do not place this product in environment with humidity higher than 90% for long term use.',
  cp_magpie_wireless_desc: 'Bluetooth',
  cp_magpie_sizeWeight_0_items_0_label: '131 × 37 × 12.4 mm',
  cp_magpie_sizeWeight_0_items_1_label: '30 g (without battery)',
  cp_magpie_powerInfo_0_label: 'One CR2032 button cell lasts for 8 months',
  cp_magpie_powerInfo_1_label: ' ',
  cp_magpie_powerInfo_1_note: 'The battery life will vary depending on the actual use environment.',
  cp_magpie_mounting: 'Magnets built-in',
  bluetooth_gateway_link: 'Qingping Bluetooth Gateway',
  
  detection_text_mi: 'Mi Home: Need to set up a Mi Home Bluetooth gateway device, such as {bluetoothGatewayLink}. Supports automation with Mi Home compatible devices.',
  detection_text_plus_iot: 'Qingping+ and Qingping IoT: Need to set up {bluetoothGatewayLink}.',
  detection_text_iot: 'Qingping IoT is a platform that provides devices management, data collection, visualization, and real-time alerting services for teams.',
  detection_text_magpie: 'Lee Guitars Temp & RH and Qingping+: Need to set up {bluetoothGatewayLink}.',
  pheasant_s_no_pressure: 'Qingping Temp & RH Monitor Pro S',
  
  // frogs sizeWeight
  cp_frogs_sizeWeight_0_items_0_label: 'Main Unit',
  cp_frogs_sizeWeight_0_items_1_value: '208 × 80 × 33 mm(external antenna included)',
  cp_frogs_sizeWeight_0_items_2_value: '128 g',
  
  
  cp_frogs_sizeWeight_1_items_0_label: 'Temp Probe',
  cp_frogs_sizeWeight_1_items_1_value: 'Probe: ɸ6 × 50 mm',
  cp_frogs_sizeWeight_1_items_2_value: 'Cable: ɸ5 × 1500 mm',
  cp_frogs_sizeWeight_1_items_3_value: 'Connector: 35 mm in length',
  cp_frogs_sizeWeight_1_items_4_value: '57 g',

  cp_frogs_sizeWeight_2_items_0_label: 'High-Concentration CO2 Probe (Flat Cable)',
  cp_frogs_sizeWeight_2_items_1_value: 'Probe: ɸ21 × 51 mm',
  cp_frogs_sizeWeight_2_items_2_value: 'Cable: 1.5 × 4 mm, 1500 mm in length',
  cp_frogs_sizeWeight_2_items_3_value: 'Connector: 35 mm in length',
  cp_frogs_sizeWeight_2_items_4_value: '35 g',
};